import ga from './ga'

const reportPageView = () => {
  if (typeof document === 'undefined') {
    return
  }
  ga('send', {
    hitType: 'pageview'
  })
  ga('set', {
    referrer: null
  })
}

const reportExperiment = (experimentId, variantId) => {
  ga('set', 'expId', experimentId)
  ga('set', 'expVar', variantId)
  ga('send', {
    hitType: 'event',
    eventCategory: 'experiment',
    eventAction: 'view',
    eventLabel: experimentId,
    eventValue: variantId,
    nonInteraction: true
  })
}

export { reportPageView, reportExperiment }



// WEBPACK FOOTER //
// ./common/utils/analytics.js